// src/pages/RegisterPage.tsx - TSO Integration redirect
import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext.tsx';
import { UserPlus, AlertCircle } from '../components/icons';

const RegisterPage: React.FC = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    // If already authenticated, redirect to game
    if (isAuthenticated) {
      window.location.href = '/game';
      return;
    }

    // For TSO integration, redirect to accounts system
    const currentDomain = window.location.hostname;
    
    // Skip redirect for localhost development
    const isLocalhost = currentDomain === 'localhost' || 
                       currentDomain === '127.0.0.1' ||
                       currentDomain.includes('localhost');
    
    if (!isLocalhost) {
      const accountsUrl = `https://accounts.${currentDomain.replace(/^[^.]+\./, '')}/register`;
      window.location.href = accountsUrl;
    }
  }, [isAuthenticated]);

  // Show a fallback page for localhost development
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="bg-gray-800 p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex justify-center mb-6">
          <div className="bg-blue-900 p-3 rounded-full">
            <UserPlus className="h-8 w-8 text-blue-400" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-center mb-6">Create Account</h1>
        
        <div className="bg-blue-900/50 border border-blue-500 text-blue-200 px-4 py-3 rounded-md mb-4 flex items-start">
          <AlertCircle className="h-5 w-5 mr-2 mt-0.5 flex-shrink-0" />
          <div>
            <p className="font-semibold mb-1">Shielded Onion Account Required</p>
            <p className="text-sm">Create your account through the Shielded Onion accounts system to access Layer Defender and other SO games.</p>
          </div>
        </div>
        
        <div className="text-center">
          <button
            onClick={() => {
              const currentDomain = window.location.hostname;
              const accountsUrl = `https://accounts.${currentDomain.replace(/^[^.]+\./, '')}/register`;
              window.location.href = accountsUrl;
            }}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-md transition-colors mb-4"
          >
            Create Security Onion Account
          </button>
          
          <button
            onClick={() => window.location.href = '/game'}
            className="w-full bg-gray-700 hover:bg-gray-600 text-white py-2 px-4 rounded-md transition-colors"
          >
            Play as Guest
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;